import { VIDEO_AVAILABILITY } from 'constants/actionTypes';
import { Map } from 'immutable';
import { VIDEO_CALL, VIDEO_SELFIE } from 'constants/identityMethod';

const initialState = Map({
    videocall: undefined,
    videoselfie: undefined,
});

const videoAvailability = (state = initialState, { type, data }) => {
    switch (type) {
        case VIDEO_AVAILABILITY: {
            return state.merge({
                [VIDEO_CALL]: data.videoCall,
                [VIDEO_SELFIE]: data.videoSelfie,
            });
        }

        default:
            return state;
    }
};

export default videoAvailability;
